/* efx-studio-mantel.js — T-CFG6, 2026-09-01.
 *
 * READ-ONLY, by construction. It never writes to configurator state, never dispatches an
 * event `ef-pdp-mantels.js` listens for, never calls `goToStep`, never selects a dimension,
 * a finish or an add-on, and never touches `#efmSubmit`, `#efmShopPayForm`, the surcharge
 * variant ids or the `_parent_product` / `_config_id` line properties.
 *
 * It writes ONLY to `[data-efx-companion-*]` nodes (the desktop companion the template
 * renders) and to `document.body.classList` for the mobile focus mode.
 *
 * Sources — every figure is text the configurator has ALREADY rendered:
 *   #efmTotalPrice / .efm-total-price   the running total (ef-pdp-mantels.js:339-364)
 *   #efmStepCur                          the step number the wizard is on
 *   .ef-cfg-mantel-progress__node.is-active .ef-cfg-mantel-progress__node-label
 *   #efmSumLen / #efmSumHgt / #efmSumDep the live dimension summary the wizard writes
 *   .efm-finish-preview__name            the named finish once one is picked
 */
(function () {
  'use strict';

  var wrap = document.getElementById('efmWrap');
  if (!wrap) return;

  var elTotal = document.querySelector('[data-efx-companion-total]');
  var elBuild = document.querySelector('[data-efx-companion-build]');
  var elStep = document.querySelector('[data-efx-companion-step]');
  var elLabel = document.querySelector('[data-efx-companion-label]');

  function txt(sel, root) {
    var el = (root || document).querySelector(sel);
    return el ? (el.textContent || '').trim() : '';
  }
  function set(el, v) { if (el && el.textContent !== v) el.textContent = v; }

  /* The three summary cells render an em dash until the buyer picks, and carry `.empty`
     while they do. Reading the class rather than testing the character keeps this working
     if the placeholder glyph ever changes. */
  function dim(id, unitLabel) {
    var el = document.getElementById(id);
    if (!el || el.classList.contains('empty')) return '';
    var v = (el.textContent || '').trim();
    if (!v || v === '—' || v === '-') return '';
    return unitLabel ? unitLabel + ' ' + v : v;
  }

  function sync() {
    if (elTotal) {
      var t = txt('#efmTotalPrice') || txt('.efm-total-price');
      if (t) set(elTotal, t);
    }
    if (elLabel) {
      /* "Starting at" until something has been chosen, then "Your shelf". The switch is
         driven by the wizard's own summary cells, not by a timer. */
      var chosen = !!(dim('efmSumLen') || dim('efmSumHgt') || dim('efmSumDep'));
      set(elLabel, chosen ? 'Your shelf' : 'Starting at');
    }
    if (elStep) {
      var cur = txt('#efmStepCur');
      var name = txt('.ef-cfg-mantel-progress__node.is-active .ef-cfg-mantel-progress__node-label');
      var frac = cur ? 'Step ' + cur + ' of 4' : '';
      set(elStep, [frac, name].filter(Boolean).join(' · '));
    }
    if (elBuild) {
      var parts = [];
      /* A mantel has a LENGTH, not an opening — the nouns here are the wizard's own. */
      var L = dim('efmSumLen'), H = dim('efmSumHgt'), D = dim('efmSumDep');
      if (L) parts.push(L + ' long');
      if (H) parts.push(H + ' high');
      if (D) parts.push(D + ' deep');
      var fin = txt('.efm-finish-preview__name');
      if (fin) parts.push(fin);
      set(elBuild, parts.join(' · '));
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }

  if (elTotal || elBuild || elStep || elLabel) {
    try {
      new MutationObserver(schedule).observe(wrap, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['class', 'aria-current'],
      });
    } catch (e) { }
    window.addEventListener('load', schedule, { once: true });
    schedule();
  }

  /* Mobile focus mode — ground colour only, same as the doors studio (T-CFG3 §5). The
     listener is additive and never preventDefaults, so the CTA's own href="#efmStudio"
     still does the scrolling. */
  var studio = document.getElementById('efmStudio');
  var cta = document.querySelector('[data-efx-studio-cta], [data-efx-build]');
  if (studio && cta) {
    cta.addEventListener('click', function () { document.body.classList.add('efx-building'); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) document.body.classList.remove('efx-building');
        }
      }, { threshold: 0 }).observe(studio);
    }
  }
})();

/* Length uses an in-page list so first/repeated opening stays stable after scroll.
 * The original select still owns option values and its existing change handler. */
(function () {
  'use strict';
  var native = document.getElementById('efmLengthSelect');
  if (!native || native.dataset.efLengthReady) return;
  var host = native.parentElement, active = 0, typed = '', typeTimer;
  var choices = Array.prototype.filter.call(native.options, function (o) { return o.value && !o.disabled; });
  if (!choices.length) return;
  var button = document.createElement('button'); button.type = 'button'; button.className = 'ef-length-trigger';
  button.setAttribute('role', 'combobox'); button.setAttribute('aria-expanded', 'false');
  button.setAttribute('aria-haspopup', 'listbox'); button.setAttribute('aria-controls', 'efLengthList'); button.setAttribute('aria-label', 'Shelf length');
  var list = document.createElement('div'); list.id = 'efLengthList'; list.className = 'ef-length-list'; list.setAttribute('role', 'listbox'); list.setAttribute('aria-label', 'Shelf length in inches'); list.hidden = true;
  var options = choices.map(function (source, i) { var el = document.createElement('div'); el.id = 'efLengthOption-' + i; el.setAttribute('role', 'option'); el.textContent = source.textContent; el.dataset.index = i; list.appendChild(el); return el; });
  host.appendChild(button); host.appendChild(list);
  function sync() {
    button.textContent = native.options[native.selectedIndex].textContent;
    options.forEach(function (el, i) { el.setAttribute('aria-selected', String(choices[i].value === native.value)); });
  }
  function mark(scroll) {
    options.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
    button.setAttribute('aria-activedescendant', options[active].id);
    if (scroll) { var el = options[active]; if (el.offsetTop < list.scrollTop) list.scrollTop = el.offsetTop; else if (el.offsetTop + el.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = el.offsetTop + el.offsetHeight - list.clientHeight; }
  }
  function close() { list.hidden = true; button.setAttribute('aria-expanded', 'false'); button.removeAttribute('aria-activedescendant'); host.classList.remove('ef-length-open'); }
  function open() { typed = ''; clearTimeout(typeTimer);
    active = choices.findIndex(function (o) { return o.value === native.value; }); if (active < 0) active = 0;
    list.hidden = false; host.classList.add('ef-length-open'); button.setAttribute('aria-expanded', 'true');
    var space = window.innerHeight - button.getBoundingClientRect().bottom - 88;
    list.classList.toggle('is-above', space < 180 && button.getBoundingClientRect().top > 280); mark(true);
  }
  function choose(i) {
    native.value = choices[i].value; sync(); close();
    native.dispatchEvent(new Event('input', { bubbles: true })); native.dispatchEvent(new Event('change', { bubbles: true }));
    button.focus({ preventScroll: true });
  }
  button.addEventListener('click', function () { if (list.hidden) open(); else close(); });
  button.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); e.preventDefault(); return; }
    if (e.key === 'Tab') { close(); return; }
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (list.hidden) open(); else choose(active); return; }
    if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(e.key) >= 0) {
      e.preventDefault(); if (list.hidden) { open(); return; }
      active = e.key === 'Home' ? 0 : e.key === 'End' ? options.length - 1 : Math.max(0, Math.min(options.length - 1, active + (e.key === 'ArrowDown' ? 1 : -1))); mark(true); return;
    }
    if (/^[0-9]$/.test(e.key)) { e.preventDefault(); if (list.hidden) open(); typed += e.key; clearTimeout(typeTimer); typeTimer = setTimeout(function () { typed = ''; }, 800); var found = choices.findIndex(function (o) { return o.value.indexOf(typed) === 0; }); if (found >= 0) { active = found; mark(true); } }
  });
  list.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') e.preventDefault(); });
  list.addEventListener('click', function (e) { var option = e.target.closest('[data-index]'); if (option) choose(Number(option.dataset.index)); });
  document.addEventListener('pointerdown', function (e) { if (!host.contains(e.target)) close(); });
  document.addEventListener('focusin', function (e) { if (!host.contains(e.target)) close(); });
  native.addEventListener('focus', function () { button.focus({ preventScroll: true }); });
  native.addEventListener('change', sync);
  native.setAttribute('aria-hidden', 'true'); native.tabIndex = -1; native.dataset.efLengthReady = 'true'; sync();
}());

/* Explicit local save/resume for the steel shelf. Restore through the existing
 * controls so today's validation/pricing owns every restored choice. No cart API. */
(function(){
 'use strict';
 var wrap=document.getElementById('efmWrap'),handle='custom-steel-fireplace-mantel-shelves-non-combustible-exceptional-fire';
 if(!wrap||location.pathname.split('/').pop()!==handle)return;
 var key='ef-mantel-draft-v1:'+handle,selectedFinish=null,record=null;
 function q(s){return wrap.querySelector(s)}
 function all(s){return Array.prototype.slice.call(wrap.querySelectorAll(s))}
 function step(){var e=q('.ef-cfg-mantel-step.is-visible');return e?Number(e.dataset.step)||1:1}
 function val(id){var e=document.getElementById(id);return e?e.value:''}
 function dimension(id){var e=document.getElementById(id);return e&&e.value!==''?parseFloat(e.options[e.selectedIndex].textContent):null}
 function finish(){var e=q('.efm-swatch[aria-checked="true"]');return e?{label:e.getAttribute('aria-label'),tier:q('.efm-finish-tab.is-active').dataset.tier}:selectedFinish}
 wrap.addEventListener('click',function(e){if(e.target.closest('.efm-swatch'))selectedFinish=finish()});
 function snapshot(){return{version:1,path:location.pathname,at:Date.now(),step:step(),length:val('efmLengthSelect'),height:dimension('efmHeight'),depth:dimension('efmDepth'),finish:finish(),addons:all('.ef-cfg-mantel-addon-card.is-active').map(function(e){return{group:e.dataset.addonGroup,name:e.querySelector('.ef-cfg-mantel-addon-card__name').textContent}}),notes:val('efmNotes')}}
 function status(text){all('.ef-mantel-save-status').forEach(function(e){e.textContent=text})}
 all('.ef-cfg-mantel-nav').forEach(function(nav){
  var row=document.createElement('div');row.className='ef-mantel-save-row';row.innerHTML='<button type="button" class="ef-mantel-save"><svg aria-hidden="true" width="14" height="16" viewBox="0 0 14 16" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M3 2h8v12l-4-3-4 3z"/></svg>Save &amp; finish later</button><p class="ef-mantel-save-status" role="status"></p>';
  nav.append(row);row.querySelector('button').addEventListener('click',function(){try{localStorage.setItem(key,JSON.stringify(snapshot()));status('Saved in this browser. Come back whenever you’re ready.')}catch(e){status('Your browser could not save this design. Keep this tab open to continue.')}});
 });
 var helper=document.getElementById('efmNavHelper');if(helper)helper.textContent='4 steps · save anytime';
 try{record=JSON.parse(localStorage.getItem(key))}catch(e){}
 if(!record||record.version!==1||record.path!==location.pathname||!Number.isFinite(record.at)||Date.now()-record.at>30*86400000)return;
 var banner=document.createElement('div');banner.className='ef-mantel-resume';banner.innerHTML='<p><strong>Your saved mantel is ready.</strong> Continue where you left off.</p><button type="button" data-resume>Resume design</button><button type="button" data-discard>Start fresh</button>';wrap.prepend(banner);
 banner.querySelector('[data-discard]').addEventListener('click',function(){try{localStorage.removeItem(key)}catch(e){}banner.remove()});
 banner.querySelector('[data-resume]').addEventListener('click',function(){
  var valid=true;
  function restoreSelect(id,value,numeric){if(value===null||value==='')return;var e=document.getElementById(id),o=Array.prototype.find.call(e.options,function(o){return o.value!==''&&(numeric?parseFloat(o.textContent)===value:o.value===value)});if(!o){valid=false;return}e.value=o.value;e.dispatchEvent(new Event('change',{bubbles:true}))}
  restoreSelect('efmLengthSelect',record.length,false);restoreSelect('efmHeight',record.height,true);restoreSelect('efmDepth',record.depth,true);
  if(record.finish){var tab=all('.efm-finish-tab').find(function(e){return e.dataset.tier===record.finish.tier});if(tab)tab.click();var sw=all('.efm-swatch').find(function(e){return e.getAttribute('aria-label')===record.finish.label});if(sw)sw.click();else valid=false;}
  if(Array.isArray(record.addons))record.addons.forEach(function(a){var card=all('.ef-cfg-mantel-addon-card').find(function(e){return e.dataset.addonGroup===a.group&&e.querySelector('.ef-cfg-mantel-addon-card__name').textContent===a.name});if(card)card.click();else valid=false});
  if(typeof record.notes==='string')document.getElementById('efmNotes').value=record.notes;
  if(valid){var target=Math.max(1,Math.min(4,Number(record.step)||1));for(var i=1;i<target;i++){if(step()!==i)break;var next=document.getElementById('efmNext'+i);if(next)next.click()}}
  banner.remove();status(valid?'Design restored. Review your options and current price.':'Some saved options have changed. Review your selections before continuing.');
  var current=q('.ef-cfg-mantel-step.is-visible');if(current){current.scrollIntoView({block:'start',behavior:'instant'});var heading=current.querySelector('h2');if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true})}}
 });
})();
